interface Iprops {
  className?: string
}

function TickSvg(props: Iprops) {
  const { className } = props
  return (
    <svg
      className={className}
      width='40'
      height='40'
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M0 0H28C34.6274 0 40 5.37258 40 12V40L0 0Z' fill='white' />
      <path
        d='M21 12L24.5 15.5L32 8'
        stroke='black'
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default TickSvg
